import {Action} from 'redux'
import {AppointmentTypeModel} from '../Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialAppointmentTypeState: IAppointmentTypeState = {
  data: {
    appointmentType: [],
    meta: {},
  },
  meetingType: [],
  loading: false,
  success: false,
  editSuccess: false,
  activateSuccess: false,
  deactivateSuccess: false,
  deleteSuccess: false,
  toggleLoading: false,
  singleActivateSuccess: false,
  singleDeactivateSuccess: false,
}

export interface IAppointmentTypeState {
  data: {
    appointmentType: {[key: string]: number | string}[]
    meta: {[key: string]: number}
  }
  meetingType: {[key: string]: number | string}[]
  appointmentList?: {appointmentType: AppointmentTypeModel[] | any}
  loading: false
  success: false
  editSuccess: false
  activateSuccess: false
  deactivateSuccess: false
  deleteSuccess: false
  toggleLoading: false
  singleActivateSuccess: false
  singleDeactivateSuccess: false
}

export const reducer = (
  state: IAppointmentTypeState = initialAppointmentTypeState,
  action: ActionWithPayload<IAppointmentTypeState>
) => {
  switch (action.type) {
    //Get appointment Type Reducer
    case actionTypes.GET_MEETING_TYPE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_MEETING_TYPE_SUCCESS: {
      return {...state, meetingType: action.payload?.meetingType, loading: false}
    }

    case actionTypes.GET_MEETING_TYPE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Get appointment Type Reducer
    case actionTypes.GET_APPOINTMENT_TYPE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_APPOINTMENT_TYPE_SUCCESS: {
      return {...state, data: action.payload?.data, loading: false}
    }

    case actionTypes.GET_APPOINTMENT_TYPE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Get appointment Type Reducer
    case actionTypes.GET_ALL_APPOINTMENT_TYPE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_APPOINTMENT_TYPE_SUCCESS: {
      return {
        ...state,
        data: action.payload?.data,
        bannerList: action.payload?.data,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_APPOINTMENT_TYPE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }
    //Add appointment Type Reducer
    case actionTypes.ADD_APPOINTMENT_TYPE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_APPOINTMENT_TYPE_SUCCESS: {
      const appointmentTypeData = action.payload
      return {...state, success: true, loading: false}
    }

    case actionTypes.ADD_APPOINTMENT_TYPE_FINISH: {
      const error = action.payload
      return {...state, error, success: false, loading: false}
    }

    case actionTypes.ADD_APPOINTMENT_TYPE_RESET: {
      return {...state, success: false, data: [], loading: false}
    }

    //update appointment Type
    case actionTypes.UPDATE_APPOINTMENT_TYPE_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_APPOINTMENT_TYPE_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_APPOINTMENT_TYPE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.UPDATE_APPOINTMENT_TYPE_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }
    //Delete appointment Type
    case actionTypes.DELETE_APPOINTMENT_TYPE_START: {
      return {...state, loading: true, deleteSuccess: false}
    }

    case actionTypes.DELETE_APPOINTMENT_TYPE_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_APPOINTMENT_TYPE_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Activate appointment Type
    case actionTypes.ACTIVATE_APPOINTMENT_TYPE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ACTIVATE_APPOINTMENT_TYPE_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.ACTIVATE_APPOINTMENT_TYPE_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    //Single Activate appointment Type
    case actionTypes.SINGLE_ACTIVATE_APPOINTMENT_TYPE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_APPOINTMENT_TYPE_SUCCESS: {
      const changedData: any = action.payload?.data?.appointmentType
      let newData = state?.data?.appointmentType?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, banner: newData},
        singleActivateSuccess: true,
        toggleLoading: false,
      }
    }
    case actionTypes.SINGLE_ACTIVATE_APPOINTMENT_TYPE_FINISH: {
      return {...state, singleActivateSuccess: false, toggleLoading: false}
    }

    //Deactivate appointment Type
    case actionTypes.DEACTIVATE_APPOINTMENT_TYPE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DEACTIVATE_APPOINTMENT_TYPE_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.DEACTIVATE_APPOINTMENT_TYPE_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_APPOINTMENT_TYPE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_APPOINTMENT_TYPE_SUCCESS: {
      const changedData: any = action.payload?.data?.appointmentType
      let newData = state?.data?.appointmentType?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, banner: newData},
        singleDeactivateSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DEACTIVATE_APPOINTMENT_TYPE_FINISH: {
      return {...state, singleDeactivateSuccess: false, toggleLoading: false}
    }

    default:
      return state
  }
}
